import { BigNumber, Contract } from "ethers";
import { _getProvider } from "./ethereum";
import FASTFOOD_ABI from "./abi/fastfood.abi";

export const getBalanceOfFastfood = async (address) => {
  const provider = _getProvider();
  if (!provider) return BigNumber.from("0");
  try {
    const signer = provider.getSigner();
    const contract = new Contract(process.env.REACT_APP_FAST_FOOD, FASTFOOD_ABI, signer);
    return await contract.balanceOf(address);
  } catch (e) {
    /* console.log(e); */
    return BigNumber.from("0");
  }
};
